// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ShopOrderItemListResultModel from '../../model/shop-order-item-list-result-model';
import ShopOrderItemListResultDTO from '../dto/shop-order-item-list-result-dto';
import dtoSchema from '../schemas/shop-order-item-list-result-schema';
import ShopOrderItemModel from '../../model/shop-order-item-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class ShopOrderItemListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ShopOrderItemListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => ShopOrderItemModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: ShopOrderItemModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<ShopOrderItemListResultDTO>): ShopOrderItemListResultModel;
  static toModel(dto: DeepPartial<ShopOrderItemListResultDTO> | undefined | null): ShopOrderItemListResultModel | undefined;
  static toModel(dto: DeepPartial<ShopOrderItemListResultDTO> | undefined | null): ShopOrderItemListResultModel | undefined {
    return dto ? new ShopOrderItemListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ShopOrderItemListResultModel> | ShopOrderItemListResultModel): ShopOrderItemListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as ShopOrderItemListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for ShopOrderItemListResultModel, can not map to ShopOrderItemListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
